<script>
  /**
   * Represents the current value of the input field.
   * @type {string}
   * @default ''
   */
  export let value = '';

  /**
   * Represents a reference to the input field.
   * @type {Object}
   * @default null
   */
  export let ref = null;

  /**
   * Determines if the input should be checked or not
   * @type {boolean}
   * @default null
   */
  export let checked = false;

  /**
   * Represents the disabled state of the input field.
   * @type {boolean}
   * @default null
   */
  export let disabled = null;

  /**
   * Represents the name of the input field.
   * @type {string}
   * @default ''
   */
  export let group = '';

  /**
   * Represents the regular expression pattern used for validation.
   * @type {string}
   * @default null
   */
  export let pattern = null;

  /**
   * Represents the validation status based on the pattern and input value.
   * @type {boolean}
   * @default true if pattern is null
   */
  export let valid = pattern === null;

  /**
   * Regular expression object created from the provided pattern.
   * @type {RegExp}
   */
  const regexp = new RegExp(pattern);

  /**
   * Represents the type of the input field.
   * @type {string}
   * @default 'text'
   */
  export let type = 'text';

  /**
   * Watches the 'pattern' and 'value' variables and updates 'valid' accordingly.
   * @type {boolean}
   */
  $: valid = pattern ? regexp.test(value) : true;
</script>

{#if type === 'checkbox'}
  <input
    bind:this={ref}
    type="checkbox"
    aria-disabled={disabled}
    on:click
    on:input
    on:change
    on:focus
    on:blur
    on:keyup
    on:keypress
    on:keydown
    bind:checked
    bind:value
    {disabled}
    {valid}
    {...$$restProps}
  />
{:else if type === 'radio'}
  <input
    bind:this={ref}
    type="radio"
    aria-disabled={disabled}
    on:click
    on:input
    on:change
    on:focus
    on:blur
    on:keyup
    on:keypress
    on:keydown
    bind:group
    bind:value
    {disabled}
    {valid}
    {...$$restProps}
  />
{:else}
  <input
    bind:this={ref}
    aria-disabled={disabled}
    on:click
    on:input
    on:change
    on:focus
    on:blur
    on:keyup
    on:keypress
    on:keydown
    bind:value
    {disabled}
    {valid}
    {...$$props}
  />
{/if}

<style lang="scss" src="./input.scss"></style>
